import styled from '@emotion/styled';
import {Grid} from '@mui/material';

export const DataGridComponentDiv = styled('div')`
  .MuiDataGrid-main {
    border: 1px solid #0000001a;
    border-radius: 5px;
    margin-top: 0.5rem;
    max-height: 55vh;
    box-shadow: (0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px,
      rgb(0 0 0 / 12%) 0px 1px 3px;
  }
  .data-grid-wrapper {
    margin: 0 !important;
    overflow-y: hidden !important;
  }
`;

export const InputFieldGrid = styled(Grid)`
  margin-top: 0.5rem;
`;

export const NoDataGridComponentDiv = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-top: 5rem;
`;
